import type { Dispatch } from "redux";

import { errorConstants } from "./types";

export const flushErrors = () => {
  return (dispatch: Dispatch) => {
    dispatch({ type: errorConstants.FLUSH_ERRORS });
  };
};

// clears only the named error keys, unlike flushErrors
export const clearErrors = (keys: string[]) => ({
  type: errorConstants.CLEAR_ERRORS,
  keys,
});
